export default {_name:'button.inverted',module:'Field',view:'Element/Button',options:{variant:'contained',color:'transparent',xs:10,sm:8,md:5}}